export { default } from "../../src/features/arrangements/screens/FamilyArrangementStudioScreen";
